/**
 * @prettier
 */

import IconButton from "../../../components/IconButton";
import { useTranslation } from "react-i18next";

export function useRotatableImageContainer({ isTwoPagePassport = false } = {}) {
    const { t } = useTranslation();

    const handleRotation = () => {
        const rotatableImage = document.getElementById(
            "document-image-rotatable"
        );
        const container = document.getElementById("rotatable-container");

        const newDegree = parseInt(rotatableImage.dataset.degree) + 90;

        if (newDegree % 180 === 0) {
            container.style.height = rotatableImage.clientHeight + "px";
        } else {
            container.style.height = rotatableImage.clientWidth + "px";
        }

        rotatableImage.dataset.degree = newDegree.toString();
        rotatableImage.style.transform = "rotate(" + newDegree + "deg)";
    };

    const ImageContainer = ({ imageAltText, cardImage }) => (
        <>
            <div
                id="rotatable-container"
                data-two-page-passport={
                    isTwoPagePassport ? true : undefined
                }
            >
                {cardImage && (
                    <img
                        id="document-image-rotatable"
                        alt={imageAltText}
                        src={cardImage}
                        data-degree="0"
                        className="capture"
                    />
                )}
            </div>
            <RotateButton />
        </>
    );
    const RotateButton = () => (
        <div>
            <IconButton
                handleClick={handleRotation}
                label={t("idpal_rotate_this_image")}
                className="rotate-button"
            />
        </div>
    );
    return { ImageContainer, RotateButton, handleRotation };
}
